<template>
  <v-sheet>

    <v-btn v-if="!hideButtons" icon small outline color="accent" class="left ma-0 ml-2"
           @click.stop="internalValue--" :disabled="internalValue <= min">
      <v-icon small>remove</v-icon>
    </v-btn>

    <input type="text" class="left text-xs-center font-weight-bold mx-2 number__input"
           aria-label="value"
           :class="type === 'number' ? 'width-40' : 'width-60'"
           @blur="checkValueOnBlur" @input="checkValueOnInput"
           :value="internalValue" @click.stop/>

    <span v-if="!isNaN(max) || !!suffix" class="left font-weight-bold line-height-28 mr-2">
      <span v-show="!isNaN(max)">/ {{ max }}</span>
      <span v-show="!!suffix"> {{ suffix }}</span>
    </span>

    <v-btn v-if="!hideButtons" icon small outline color="accent" class="left ma-0 mr-2"
           @click.stop="internalValue++" :disabled="!isNaN(max) && internalValue >= max">
      <v-icon small>add</v-icon>
    </v-btn>

  </v-sheet>
</template>

<script>
export default {
    name: 'NumberInput',
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        max: Number,
        min: {
            type: Number,
            default: 1
        },
        hideButtons: Boolean,
        type: {
            type: String,
            default: 'number' //  Valori possibili: number, price
        },
        suffix: String
    },
    computed: {
        internalValue: {
            get () {
                return this.value
            },
            set (val) {
                if (!!val && this.type === 'price') {
                    val = parseFloat(val).toFixed(2)
                }
                this.$emit('input', val)
            }
        }
    },
    methods: {
        checkValueOnBlur (event) {
            let newVal = event.target.value
            if (!newVal || isNaN(newVal)) {
                //  Valore vuoto, ripristino il valore a 1
                this.internalValue = this.min
            }
        },
        //  Controllo sul valore inserito nell'input. Il valore può essere null per poter cancellare il numero
        checkValueOnInput (event) {
            let newVal = event.target.value
            if (!!newVal && (!this.isValid(newVal) || newVal < this.min || newVal > this.max)) {
                //  Valore quantità non valido, riporto il valore a quello precedente
                let _internalValue = this.internalValue
                this.$nextTick(function () {
                    event.target.value = _internalValue
                })
            } else {
                //  Valore quantità valido
                this.internalValue = newVal
            }
        },
        isValid (val) {
            if (this.type === 'number') {
                return /^\d+$/.test(val)
            } else if (this.type === 'price') {
                return /^(\d*[.])?\d{0,2}$/.test(val)
            }
            return true
        }
    }
}
</script>
<style lang="scss" scoped>
  .number__input {
    &, &:focus {
      outline: none;
    }

    border-radius: 10px;
    border: solid 1px #00838f;
    height: 28px;
  }
</style>
